import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const VALID = { calendar: "/kalender", dashboard: "/dashboard", jobs: "/auftraege" };
const CACHE_KEY = "stellar_startup_page";

/**
 * Redirects the user to the configured startup page.
 * - Reads `startup_page` from /api/business/config
 * - Uses localStorage-cached value for instant redirect (avoids Dashboard flash)
 * - Defaults to '/kalender' when nothing is configured
 */
export default function StartupRedirect() {
  const cached = typeof window !== "undefined" ? localStorage.getItem(CACHE_KEY) : null;
  const [target, setTarget] = useState(VALID[cached] || "/kalender");
  const [ready, setReady] = useState(!!cached);   // If we have a cache, go now.

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/business/config");
        const key = data?.startup_page || "calendar";
        if (!alive) return;
        localStorage.setItem(CACHE_KEY, key);
        // If we didn't have a cache, this is the first navigation — update target.
        if (!cached) { setTarget(VALID[key] || "/kalender"); setReady(true); }
      } catch {
        if (alive && !cached) { setTarget("/kalender"); setReady(true); }
      }
    })();
    return () => { alive = false; };
  }, [cached]);

  if (!ready) {
    return <div className="flex h-screen items-center justify-center text-muted-foreground text-sm">Öffne Startseite…</div>;
  }
  return <Navigate to={target} replace />;
}
